import React, { useEffect, useRef, useState } from 'react'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../../routes/routeName'
import { Grid, Typography } from '@mui/material'
import { ButtonOutlined, ButtonPrimary } from '../../../../components/button/ButtonCustoms'
import TextEditorCustom from '../../../../components/text-editor/TextEditorCustom'
import InputTextField from '../../../../components/input/inputTextField'
import { OnlineCourseApi } from '../../../../api/cms-online-course/online_course.api'
import { alertActive, alertError, swalActive, swalError, swalSuccess } from '../../../../components/alert/swal'
import { NavigateFunction, useLocation, useNavigate, useParams } from 'react-router-dom'
import parse from "html-react-parser";
import { useReactToPrint } from "react-to-print";

export default function OnlineCourseDiplomaCreate() {
    const { id } = useParams();
    const location = useLocation()
    const search_params = new URLSearchParams(location.search);
    const view = search_params.get("view")
    const navigate: NavigateFunction = useNavigate();
    const fileRef = useRef<any>()
    const contentRef = useRef<HTMLDivElement>(null);
    const reactToPrintFn = useReactToPrint({ contentRef });

    const [online_course_diploma, set_online_course_diploma] = useState('');
    const [value, setValue] = useState('');
    const [file, setFile] = useState<any>();
    const [filePath, setFilePath] = useState<any>();
    const handleEditorChange = (newContent: string) => {
        setValue(newContent);
    };

    const handleDragStart = (e: any, value: any) => {
        // Set the data to be transferred during the drag
        e.dataTransfer?.setData('text/plain', value); // You can use any data type here
    };
    const onImageChange = (event: any) => {
        if (event.target.files && event.target.files[0]) {
            setFile(event.target.files[0]);
            setFilePath(URL.createObjectURL(event.target.files[0]))
        }
    }

    const getData = async () => {
        await OnlineCourseApi.getDiploma(id).then((res: any) => {
            if (res.status < 300) {
                console.log(res);
                set_online_course_diploma(res.data.data.online_course_diploma)
                setValue(res.data.data.online_course_diploma_desc)
                const url = process.env.REACT_APP_FILE_BASE_API + '/' + res.data.data.file_path + res.data.data.file_name
                setFilePath(url)
            }
        }).catch((error: any) => {
            console.log(error)
            // swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }
    
    useEffect(() => {
        if (id) {
            getData()
        }
    }, [])

    const handleSubmit = async () => {

        const formData = new FormData();

        //DRAFT
        if (file) {
            formData.append('file', file);
        }
        formData.append('online_course_diploma', online_course_diploma);
        formData.append('online_course_diploma_desc', value);
        if (id) {
            await OnlineCourseApi.patchDiploma(formData, id).then((res: any) => {
                if (res.status < 300) {
                    // swalSuccess('บันทึกวุฒิบัตร', 'บันทึกวุฒิบัตร เรียบร้อยแล้ว')
                    alertActive('บันทึกวุฒิบัตร', 'บันทึกวุฒิบัตร เรียบร้อยแล้ว', 'ดูตัวอย่าง', 'ตกลง', () => {
                        // handleSubmit()
                        reactToPrintFn()
                    }, 'info',)
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        } else {
            await OnlineCourseApi.postDiploma(formData).then((res: any) => {
                if (res.status < 300) {
                    // swalSuccess('เพิ่มวุฒิบัตร', 'เพิ่มวุฒิบัตร เรียบร้อยแล้ว')
                    navigate(routeName.cms.OnlineCourseDiplomaDetail.replace(':id', res.data.data.id_online_course_diploma));
                    alertActive('เพิ่มวุฒิบัตร', 'เพิ่มวุฒิบัตร เรียบร้อยแล้ว', 'ดูตัวอย่าง', 'ตกลง', () => {
                        // handleSubmit()
                        reactToPrintFn()

                    }, 'info',)
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        }

    }

    useEffect(() => {
        // getdata()
        const style = document.createElement("style");
        style.innerHTML = `
            @page {
                margin: 0;
                size: 29.7cm 21cm;
                
              }
                 @media print {
              @page {
                size: 29.7cm 21cm;;
               }
             body,
               page {
            margin: 0;
            box-shadow: 0;
        }
    }`;
        document.head.appendChild(style);
        // getMasterGroup()
    }, []);
    return (
        <div>
            <NavigateListCustom
                navigateData={[
                    {
                        name: "จัดการข้อมูลคอร์สออนไลน์",
                        key: "1",
                        pathName: routeName.cms.OnlineCourseDiploma,
                    },
                    {
                        name: "จัดการวุฒิบัตร",
                        key: "2",
                        pathName: routeName.cms.OnlineCourseDiploma,
                    },
                    {
                        name: id ? 'ข้อมลูวุฒิบัตร' : 'เพิ่มวุฒิบัตร',
                        key: "3",
                        pathName: id ? routeName.cms.OnlineCourseDiplomaDetail.replace(':id', id) : routeName.cms.OnlineCourseDiplomaCreate,
                    },

                ]}
            />
            <div className="w-full flex justify-between mt-[40px]">
                <Typography variant="h3">{id ? 'ข้อมลูวุฒิบัตร' : 'เพิ่มวุฒิบัตร'}</Typography>

                {!view && <div className="flex gap-4">
                    <ButtonOutlined
                        onClick={() => {
                            navigate(routeName.cms.OnlineCourseDiploma)
                        }}
                        buttonName={'ยกเลิก'}
                        btnProps={{
                            width: "100px"
                        }}
                    />
                    <ButtonPrimary
                        onClick={() => {
                            if (!online_course_diploma) {
                                return alertError('เพิ่มชื่อวุฒิบัตร')
                            }
                            if (!filePath) {
                                return alertError('เพิ่มภาพพื้นหลังวุฒิบัตร')
                            }

                            swalActive('ยืนยันการบันทึกวุฒิบัตร', 'ท่านต้องการยืนยันการบันทึกวุฒิบัตร ใช่หรือไม่', () => {
                                handleSubmit()
                            }, 'info', 'ยืนยัน')


                        }}
                        mode="add"
                        buttonName={'ยืนยัน'}
                        btnProps={{
                            width: "120px"
                        }}
                    />
                </div>}
            </div>
            <div className='my-4'>
                <InputTextField heading='ชื่อวุฒิบัตร' required value={online_course_diploma || ''} onchange={(e) => {
                    set_online_course_diploma(e.target.value)
                }} disabled={!!view} />
            </div>
            <div className='my-4'>
                <Typography sx={{ fontWeight: "600" }}>ภาพพื้นหลังวุฒิบัตร 1122 x 794 pixel</Typography>
                <div style={{
                    borderRadius: '10px',
                    border: "1px solid #7e7e7e",
                    height: "600px",
                    display: "flex",
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>

                    {filePath ? <img src={filePath} style={{ height: '600px' }} onClick={() => fileRef.current.click()} /> : <img onClick={() => fileRef.current.click()} src={'https://placehold.co/600x600?text=No+Image'} />}
                    <input ref={fileRef} disabled={!!view} className='hidden' type='file' accept={"image/*"} onChange={(e: any) => onImageChange(e)} />
                </div>
            </div>
            <section className='my-4 overflow-auto'>
                <Grid container spacing={2}>
                    <Grid item lg={8}>
                        <TextEditorCustom
                            disabled={!!view}
                            sx={{ height: "100%", minHeight: "400px" }}
                            height={'400px'}
                            onChange={(text) => { handleEditorChange(text) }}
                            textString={value}
                        />
                    </Grid>
                    <Grid item lg={4}>
                        <div style={{
                            background: '#DDE1EB',
                            padding: '40px'
                        }}>
                            <Typography variant='h5'>
                                ข้อมูล
                            </Typography>
                            <Typography sx={{ marginBottom: "20px" }}>กรุณาลากข้อมูลที่ท่านต้องการนำไปวางในเอกสารของท่าน</Typography>
                            <Grid container spacing={2} >
                                {[
                                    'ชื่อ-นามสกุลผู้เรียน', 'ชื่อ-นามสกุลผู้สอน', 'ชื่อหลักสูตร', 'วันที่ออกวุฒิบัตร'
                                ].map((item: any, index: number) => {
                                    return (
                                        <Grid item lg={6} key={index}>
                                            <div
                                                draggable
                                                onDragStart={(e) => handleDragStart(e, `{{${item}}}`)}
                                                style={{ background: '#F79009', borderRadius: '50px', color: '#fff', padding: '8px 10px', textAlign: 'center' }}>
                                                {item}
                                            </div>
                                        </Grid>
                                    )
                                })
                                }
                            </Grid>
                        </div>

                    </Grid>
                </Grid>

            </section>
            <div
                style={{ display: 'none' }}
            >
                <div ref={contentRef}>
                    <div
                        style={{
                            backgroundPosition: "center",
                            backgroundSize: "cover",
                            backgroundImage: `url(${filePath})`,
                            width: '29.7cm',
                            height: "21cm",
                            display: 'flex',
                            alignItems: "center",
                            justifyContent: 'center'
                        }}
                    >
                        <div className='ck-content'>
                            {value &&
                                parse(value)}
                        </div>

                    </div>
                </div>

            </div >
        </div>
    )
}
